import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import DangerTriangle from '@/images/DangerTriangle.svg';
import theme from '@/theme';
import styled from '@emotion/styled';

const contrastColor = theme.colors.error[650];

const Container = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    gap: 8px;

    justify-self: center;
    align-self: flex-start;
    width: 100%;
    margin-bottom: 16px;
    padding: 12px;

    border-radius: 12px;
    background: ${({ theme }) => theme.colors.error[655]};
`;

const IconContainer = styled.div`
    display: flex;
    padding: 2px 0px;
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;
`;

const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 4px;
    flex: 1 0 0;
`;

const Title = styled.div`
    color: ${contrastColor};
    text-align: center;
    font-family: Manrope;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
`;

const Description = styled.div`
    color: ${contrastColor};
    font-family: Manrope;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
`;

interface AgentMissingEditBannerProps {
    title?: string;
    description?: string;
}

export const ErrorBanner = ({ title, description }: AgentMissingEditBannerProps) => {
    return (
        <Container>
            <IconContainer>
                <MaskedIcon src={DangerTriangle} size="16px" color={contrastColor} />
            </IconContainer>
            <TextContainer>
                {title && <Title>{title}</Title>}
                {description && <Description>{description}</Description>}
            </TextContainer>
        </Container>
    );
};
